import { useMemo } from 'react';
import type { FunctionComponent } from 'react';
import styled from 'styled-components';
import size from 'lodash/size';
import range from 'lodash/range';
import map from 'lodash/map';
import { getMapPosition } from '../components/molecules/MapPosition';
import type { Position } from '../components/molecules/MapPosition';
import { getPersonas } from '../data/Personas';

const DummyMap = styled.div<{
	width: number;
	height: number;
}>`
	background-color: ${(props) => props.theme.colors.white};
	border: ${(props) => props.theme.colors.black};
	height: ${(props) => props.height}px;
	position: relative;
	width: ${(props) => props.width}px;
`;

const Mark = styled.div<{ position: Position }>`
	background-color: ${(props) => props.theme.colors.darkBlue};
	border-radius: 9999px;
	color: ${(props) => props.theme.colors.white};
	height: 1em;
	left: ${(props) => props.position.x};
	line-height: 1;
	overflow: hidden;
	position: absolute;
	text-align: center;
	top: ${(props) => props.position.y};
	width: 1em;
`;

const PERSONAS = getPersonas();
const MAX_PERSONA_COUNT = size(PERSONAS);

const SCREEN_WIDTH = 1920 * 0.2;
const SCREEN_HEIGHT = 1080 * 0.2;

interface Props {
	count?: number;
}

const MapInfo: FunctionComponent<Props> = (props: Props) => {
	const { count = MAX_PERSONA_COUNT } = props;

	const positionElements = useMemo(() => {
		return map(range(0, count), (index) => {
			const position = getMapPosition(index);
			return (
				<Mark key={index} position={position}>
					{index}
				</Mark>
			);
		});
	}, [count]);

	return (
		<DummyMap width={SCREEN_WIDTH} height={SCREEN_HEIGHT}>
			{positionElements}
		</DummyMap>
	);
};

export default MapInfo;
